export default {
  features: {
    showBnplContract: {
      button: "Akt ko'rsatish",
    },
  },
};
